import { render } from "./educationForm.vue?vue&type=template&id=4d2cea8d&scoped=true"
import script from "./educationForm.vue?vue&type=script&lang=js"
export * from "./educationForm.vue?vue&type=script&lang=js"

import "./educationForm.vue?vue&type=style&index=0&id=4d2cea8d&scoped=true&lang=css"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d2cea8d"]])

export default __exports__